import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const useStyles = makeThemedStyles("mytasks", (theme) => ({
  pageContainer: {
    background: "rgba(225, 245, 255, 0.5)",
    height: "100%",
    minWidth: "unset",
  },
}));

const MyTasksContainer = (props: React.PropsWithChildren<{}>) => {
  const styles = useStyles();
  return <div className={styles.pageContainer}>{props.children}</div>;
};

export default MyTasksContainer;
